import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=112d99ef&"
import script from "./classify.vue?vue&type=script&lang=js&"
export * from "./classify.vue?vue&type=script&lang=js&"
import style0 from "./classify.vue?vue&type=style&index=0&id=112d99ef&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports